import React, { Component } from 'react';
import {Link} from 'react-router-dom';
class Banner extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

  componentDidMount() {

  }


  render() {
    return (
       <div className="container-xxl py-5 bg-dark page-header page-header_about">
            <div className="container my-5 pt-5 pb-4">
                <h1 className="display-3 text-white mb-3 animated slideInDown">About Us</h1>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb text-uppercase">
                        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                        <li className="breadcrumb-item text-white active" aria-current="page">About</li>
                    </ol>
                </nav>
            </div>
        </div>
    );
  }
}

export default Banner;
